import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { fetchStudents, fetchSubjectFaculty, addDailyReport } from '../../redux/action/facultyAction';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory, Link } from 'react-router-dom';

const AttendenceFaculty = () => {
    const store = useSelector((store) => store);
    const history = useHistory();
    const dispatch = useDispatch();
    const [year, setYear] = useState('');
    const [section, setSection] = useState('');
    const [semester, setSemester] = useState('');
    const [error, setError] = useState({});
    const [errorHelper, setErrorHelper] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const date = new Date();
    const today = date.getDate();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits
    const thisYear = date.getFullYear();
    const time = `${thisYear}-${month}-${today.toString().padStart(2, '0')}`; // Ensure two digits
    useEffect(() => {
        if (store.errorHelper) {
            setErrorHelper(store.errorHelper)
        }
    }, [store.errorHelper])



    useEffect(() => {
        if (store.error) {
            setError(store.error);
        }
    }, [store.error]);

    const department = store.faculty.faculty.faculty.department;
    const formHandler = (e) => {
        e.preventDefault();
        setIsLoading(false); // Clear previous loading state
        setIsLoading(true);
        dispatch(fetchStudents(department, year, section, semester))
            .finally(() => {
                setIsLoading(false);
            });
        dispatch(fetchSubjectFaculty(department, year, section, semester))
            .finally(() => {
                setIsLoading(false);
            });
    };


    useEffect(() => {
        if (store.error || !store.faculty.fetchedStudentsHelper) {
            setIsLoading(false);
        }
    }, [store.error, store.faculty.fetchedStudentsHelper]);

    // Reset loading state when the parameters for fetchStudents change
    useEffect(() => {
        setIsLoading(false);
    }, [department, year, section, semester]);



    useEffect(() => {
        if (store.faculty.fetchedStudentsHelper) {
            setIsLoading2(false);
        }
    }, [store.faculty.fetchedStudentsHelper]);
    console.log(date,department, year, section, semester)
    const [periods, setPeriods] = useState(
        Array.from({ length: 8 }, (_, index) => ({
            date: time,
            department: department || '', 
            year: year || '',
            section: section || '',
            semester: semester || '',
            period: index + 1,
            subjectName: '',
            faculty: '',
            portionCovered: '',
            unit: '',
            presentCount: 0,
            absentCount: 0,
            errors: {},
        }))
    );
    useEffect(() => {
        setPeriods((prevPeriods) =>
            prevPeriods.map((period, index) => ({
                ...period,
                year,
                section,
                semester,
                department
            }))
        );
    }, [year, section, semester, department]);
    const handleInputChange = (index, field, value) => {
        const updatedPeriods = [...periods];
        updatedPeriods[index][field] = value;

        // Optionally, add validation here and set errors
        if (field === 'presentCount' || field === 'absentCount') {
            const present = parseInt(updatedPeriods[index].presentCount, 10);
            const absent = parseInt(updatedPeriods[index].absentCount, 10);

            if (!isNaN(present) && !isNaN(absent)) {
                if (present + absent < 0) {
                    updatedPeriods[index].errors.total = 'Present + Absent cannot be negative';
                } else {
                    delete updatedPeriods[index].errors.total;
                }
            }
        }

        setPeriods(updatedPeriods);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate all periods
        let isValid = true;
        const updatedPeriods = periods.map(period => {
            const errors = {};
            if (!period.subjectName) errors.subjectName = 'Subject Name is required';
            if (!period.faculty) errors.faculty = 'Faculty is required';
            if (!period.portionCovered) errors.portionCovered = 'Portion Covered is required';
            if (!period.unit) errors.unit = 'Unit is required';
            if (period.presentCount + period.absentCount < 0) {
                errors.total = 'Present + Absent cannot be negative';
                isValid = false;
            }
            return { ...period, errors };
        });

        setPeriods(updatedPeriods);

        if (!isValid) {
            return;
        }

        // Prepare data for submission
        const submissionData = {
            date: updatedPeriods[0].date, // Assuming all periods have the same date
            department: updatedPeriods[0].department,
            year: updatedPeriods[0].year,
            section: updatedPeriods[0].section,
            semester: updatedPeriods[0].semester,
            periods: updatedPeriods.map(({ period, subjectName, faculty, portionCovered, unit, presentCount, absentCount }) => ({
                period,
                subjectName,
                faculty,
                portionCovered,
                unit,
                presentCount: parseInt(presentCount, 10), // Ensure this is a number
                absentCount: parseInt(absentCount, 10) // Ensure this is a number
            }))
        };

        // Handle form submission (e.g., send to API)
        console.log('Submitting Attendance Data:', submissionData);
        dispatch(addDailyReport(submissionData))
        // You can dispatch an action or make an API call here
    };

    return (
        <div>
            {store.faculty.isAuthenticated ? (
                <>
                    <div className="container-fluid p-0">
                        <div className="d-flex">
                            <div className="print-helper">
                                <FacultyHomeHelper />
                            </div>
                            <div className="mx-1 w-100 ">
                                <div className="px-3 py-1 bg-light d-flex align-items-center justify-content-between">
                                    <h5>
                                        <Link to="/attendenceFaculty" className="text-light">
                                            <img src="/image/Back.svg" className="p-2" alt="" />
                                        </Link>
                                    </h5>
                                    <h3>
                                        <img src="/logo192.png" width={'50px'} alt="" /> Mark Attendance
                                    </h3>
                                    <button
                                        onClick={() => window.print()}
                                        type="button"
                                        className=" btn-success btn text-light"
                                    >
                                        <img src="/image/print.svg" alt="" /> Download
                                    </button>
                                </div>
                                <div className="col d-md-flex align-items-center justify-content-between ">
                                    <form
                                        className="d-md-flex align-items-center justify-content-start"
                                        noValidate
                                        onSubmit={formHandler}
                                    >
                                        <div className="form-group mx-2 print-helper">
                                            <label htmlFor="semesterId">Date</label> <br />
                                            <h5>{time}</h5>
                                            {error.semester && (
                                                <div className="invalid-feedback">{error.semester}</div>
                                            )}
                                        </div>
                                        <div className="form-group mx-2 print-helper">
                                            <label htmlFor="yearId">Year</label>
                                            <select
                                                onChange={(e) => setYear(e.target.value)}
                                                className={classnames('form-control', {
                                                    'is-invalid': error.year
                                                })}
                                                id="yearId"
                                            >
                                                <option>Select</option>
                                                <option value="I">1</option>
                                                <option value="II">2</option>
                                                <option value="III">3</option>
                                                <option value="IV">4</option>
                                            </select>
                                            {error.year && (
                                                <div className="invalid-feedback">{error.year}</div>
                                            )}
                                        </div>
                                        <div className="form-group mx-2 print-helper">
                                            <label htmlFor="sectionId">Section</label>
                                            <select
                                                onChange={(e) => {
                                                    setSection(e.target.value);
                                                }}
                                                className={classnames('form-control', {
                                                    'is-invalid': error.section
                                                })}
                                                id="sectionId"
                                            >
                                                <option>Select</option>
                                                <option value="A">A</option>
                                                <option value="B">B</option>
                                                <option value="C">C</option>
                                                <option value="D">D</option>
                                            </select>
                                            {error.section && (
                                                <div className="invalid-feedback">{error.section}</div>
                                            )}
                                        </div>
                                        <div className="form-group mx-2 print-helper">
                                            <label htmlFor="semesterId">Semester</label>
                                            <select
                                                onChange={(e) => {
                                                    setSemester(e.target.value);
                                                }}
                                                className={classnames('form-control', {
                                                    'is-invalid': error.section
                                                })}
                                                id="semesterId"
                                            >
                                                <option>Select</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                            </select>
                                            {error.semester && (
                                                <div className="invalid-feedback">{error.semester}</div>
                                            )}
                                        </div>

                                        <div className="mt-3 position-relative">
                                            {!isLoading && (
                                                <button
                                                    type="submit"
                                                    className="btn btn-info btn-block print-helper"
                                                >
                                                    <img
                                                        src="/image/search.svg"
                                                        className="mb-1"
                                                        alt=""
                                                    />{' '}
                                                    Search
                                                    <span className="badge badge-warning position-absolute top-0 end-0">
                                                        {store.faculty.fetchedStudents.length}
                                                    </span>
                                                </button>
                                            )}
                                            {isLoading && (
                                                <div
                                                    className="spinner-border text-primary"
                                                    role="status"
                                                >
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            )}
                                        </div>


                                    </form>
                                </div>

                                {!store.faculty.fetchedStudentsHelper && <div className="row justify-content-center m-0">
                                    <div className="col">
                                        <div>
                                            <form onSubmit={handleSubmit}>
                                                <table className="table table-bordered table-striped">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th scope="col">Period</th>
                                                            <th scope="col">Subject Name</th>
                                                            <th scope="col">Faculty</th>
                                                            <th scope="col">Portion Covered</th>
                                                            <th scope="col">Unit</th>
                                                            <th scope="col">Present Count</th>
                                                            <th scope="col">Absent Count</th>
                                                            <th scope="col">Errors</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {periods.map((periodData, index) => (
                                                            <tr key={periodData.period}>
                                                                <td>{periodData.period}</td>
                                                                <td>
                                                                    <select
                                                                        className={classnames("form-control", {
                                                                            'is-invalid': periodData.errors.subjectName
                                                                        })}
                                                                        value={periodData.subjectName}  // Ensuring the selected value is bound to `periodData.subjectName`
                                                                        onChange={(e) => handleInputChange(index, 'subjectName', e.target.value)}  // Handling the selection change
                                                                    >
                                                                        <option value="">Select Subject</option>  {/* Default option */}
                                                                        {store.faculty.subjectFacultyList.subjectCode?.map((subjectCode, idx) => (
                                                                            <option key={subjectCode} value={subjectCode}>
                                                                                {store.faculty.subjectFacultyList.subjectName?.[idx]}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    {/* Display error if subjectName has an issue */}
                                                                    {periodData.errors.subjectName && (
                                                                        <div className="invalid-feedback">{periodData.errors.subjectName}</div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    <select
                                                                        className={classnames("form-control", {
                                                                            'is-invalid': periodData.errors.faculty
                                                                        })}
                                                                        value={periodData.faculty}  // Binding selected faculty to `periodData.faculty`
                                                                        onChange={(e) => handleInputChange(index, 'faculty', e.target.value)}  // Handling selection change
                                                                    >
                                                                        <option value="">Select Faculty</option>  {/* Default option */}
                                                                        {store.faculty.subjectFacultyList?.facultyName?.map((facultyName, idx) => (
                                                                            <option key={facultyName} value={facultyName}>
                                                                                {facultyName}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    {/* Display error if faculty name has an issue */}
                                                                    {periodData.errors.faculty && (
                                                                        <div className="invalid-feedback">{periodData.errors.faculty}</div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className={classnames("form-control", {
                                                                            'is-invalid': periodData.errors.portionCovered
                                                                        })}
                                                                        value={periodData.portionCovered}
                                                                        onChange={(e) => handleInputChange(index, 'portionCovered', e.target.value)}
                                                                        placeholder="Enter Portion Covered"
                                                                    />
                                                                    {periodData.errors.portionCovered && (
                                                                        <div className="invalid-feedback">{periodData.errors.portionCovered}</div>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className={classnames("form-control", {
                                                                            'is-invalid': periodData.errors.unit
                                                                        })}
                                                                        value={periodData.unit}
                                                                        onChange={(e) => handleInputChange(index, 'unit', e.target.value)}
                                                                        placeholder="Enter Unit"
                                                                    />
                                                                    {periodData.errors.unit && (
                                                                        <div className="invalid-feedback">{periodData.errors.unit}</div>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className={classnames("form-control", {
                                                                            'is-invalid': periodData.errors.total
                                                                        })}
                                                                        value={periodData.presentCount}
                                                                        onChange={(e) => handleInputChange(index, 'presentCount', e.target.value)}
                                                                        placeholder="Present Count"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className={classnames("form-control", {
                                                                            'is-invalid': periodData.errors.total
                                                                        })}
                                                                        value={periodData.absentCount}
                                                                        onChange={(e) => handleInputChange(index, 'absentCount', e.target.value)}
                                                                        placeholder="Absent Count"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {periodData.errors.total && (
                                                                        <span className="text-danger">{periodData.errors.total}</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <button type="submit" className="btn btn-primary">Submit Attendance</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                history.push('/')
            )}
        </div>
    );
};

export default AttendenceFaculty;
